<template>
      <section class="section-outline" v-if="isMounted">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive" class="property-mortgage-new">
            <template v-slot:header="collapsible">
                <h2 class="f2 text-bold">Mortgage calculator <sub class="sub">for {{ dpp.geo.address }}</sub></h2>
                <div class="f5 text-gray" v-show="collapsible.collapsed">{{description}}</div>
            </template>
            <template v-slot:default>
                <mvtMortgageNew
                    ref="mortgageComponent"
                    @loanPerMonthChanged="loanPerMonthChanged"
                    @monthTotalChanged="monthTotalChanged"
                    @loanDescription="updateDescription"
                    :state="dpp.geo.state"
                    :city="dpp.geo.city"
                    :zipcode="dpp.geo.zipcode"
                    :address="dpp.geo.address"
                    :subPremise="dpp.geo.subPremise"
                    :propertyType="dpp.propertyType"
                    :price="dpp.price"
                    :isActive="dpp.isActive"
                    :isOjOBrokerage="dpp.isOjOBrokerage"
                    :houseRealStatus="dpp.houseRealStatus"
                    :loadBankrateLink="dpp.loadBankrateLink"
                    :daysOnMovoto="dpp.daysOnMovoto"
                    :propertyId="dpp.propertyId"
                    :hoafee="dpp.hoafee"
                    :yearBuilt="dpp.yearBuilt"
                    :path="dpp.path"
                    :showDataSource="showDataSource" />
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-mortgage-new.js"></script>

<style lang="scss">
@use "./property-mortgage-new.scss" as *;
</style>
